// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const terapagos_terastal: PokeData = {
  "id": 10276,
  "name": "terapagos-terastal",
  "height": 3,
  "weight": 160,
  "base_experience": 90,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "headbutt",
    "double-edge",
    "withdraw",
    "tri-attack",
    "protect",
    "rapid-spin",
    "ancient-power",
    "gyro-ball",
    "rock-polish",
    "earth-power",
    "heavy-slam",
    "tera-starstorm"
  ],
  "moves": [
    "headbutt",
    "tri-attack",
    "protect",
    "ancient-power",
    "earth-power",
    "scary-face",
    "leer",
    "purification",
    "scratch",
    "growl",
    "refresh",
    "splash",
    "body-slam"
  ],
  "evolution_chain": {
    "id": 548,
    "item": null,
    "species": [
      {
        "name": "terapagos",
        "order": 1026,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 140,
    "speed": 116,
    "ability_power": 144
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
